import { useState, useEffect } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import ButtonCard from './DockingElements/ButtonCard';
import DockingCard from './DockingElements/DockingCard';
import LocationCard from './DockingElements/LocationCard';
import { useStyles } from './style';
import { Drawer, StyledButton } from '../../../components';
import { isObject } from '../../../shared/utility';
import * as actions from '../../../store/actions';

interface LinkDockingLocationProps {
	open: boolean;
	onClose(...args: unknown[]): unknown;
	locationDetails?: object;
	setLocationDetails?(...args: unknown[]): unknown;
	onResetState?(...args: unknown[]): unknown;
	onLinkDockingLocationn?(...args: unknown[]): unknown;
	linkDockingLocation?: {
		data?: object;
		loading?: boolean;
		error?: object | string;
	};
}

const LinkDockingLocation = (props: LinkDockingLocationProps) => {
	const {
		open,
		onClose,

		locationDetails,
		setLocationDetails,
		onLinkDockingLocationn,
		linkDockingLocation,
		onResetState,
	} = props;
	const { t } = useTranslation();

	const { data: linkDockingLocationData, loading: linkDockingLocationLoading } =
		linkDockingLocation;

	const classes = useStyles();

	const [docking, setDocking] = useState(null);

	const clearSelectionLocation = () => setLocationDetails(null);

	const handleClearDocking = () => setDocking(null);

	const handleLinkDockingLocation = () => {
		onLinkDockingLocationn(docking?.slug, locationDetails?.id);
	};

	useEffect(() => {
		if (!linkDockingLocationLoading && isObject(linkDockingLocationData)) {
			onClose();
			onResetState('linkDockingLocation');
		}
	}, [linkDockingLocationData]);

	useEffect(() => {
		if (!open) {
			setDocking(null);
			setLocationDetails(null);
		}
	}, [open]);

	const buttonProps = {
		size: 'large',
		variant: 'contained-primary',
		onClick: handleLinkDockingLocation,
	};

	const locationCardProps = {
		open,

		clearSelection: clearSelectionLocation,
		cardDetails: locationDetails,
		selectCardDetails: setLocationDetails,
	};

	const dockingCardProps = { open, docking, setDocking, clearSelection: handleClearDocking };

	return (
		<Drawer onClose={onClose} open={open}>
			<form className={classes.drawerForm}>
				<div>
					<ButtonCard handleCloseDrawer={onClose} />
					<Typography variant='h2'>
						{t('views.actions.linkDockingLocation.drawer.title')}
					</Typography>
					<LocationCard {...locationCardProps} />
					<DockingCard {...dockingCardProps} />
				</div>
				<StyledButton {...buttonProps}>{t('ui.confirm')}</StyledButton>
			</form>
		</Drawer>
	);
};

const mapStateToProps = (state) => {
	return {
		linkDockingLocation: state.details.linkDockingLocation,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onResetState: (state) => dispatch(actions.resetState(state)),
		onLinkDockingLocationn: (slug, locationId) =>
			dispatch(actions.linkDockingLocation(slug, locationId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkDockingLocation);
